export default __webpack_public_path__ + "static/media/logo2.75c09958.svg";